import axios from 'axios'
import * as Const from "../config/const";

function getData(){
    return axios.get(Const.defaults.base_url+'content')
}

function postData(data) {
    return axios.post(Const.defaults.base_url+'contact', data)
}

export const httpService = {
    getContent: function(){
        return axios.all([getData()])
            .then(function(arr){
                if(arr[0].data.code == 200) {
                    var result = arr[0].data.data
                    return {
                        bios: {...result.bios},
                        projects: {...result.projects},
                        images: {...result.images},
                        content: {...result.content},
                        partners: {...result.partners},
                    }
                }
            })
    },
    sendMail: function(data){
        return axios.all([postData(data)])
            .then(function (arr) {
            })
    }
}


// WEBPACK FOOTER //
// ./src/actions/httpService.js